import paginationStyles from '../css/pagination.module.scss';
import { useTranslation } from 'react-i18next';

const Pagination = ({ onPrevious, onNext, currentPage, totalPages }: { onPrevious: () => void; onNext: () => void; currentPage: number; totalPages: number }) => {
  const { t } = useTranslation();

  return (
    <div className={paginationStyles.paginationWrapper}>
      <div className={`${paginationStyles.pagination} ${paginationStyles.desktop}`}>
        <div className={paginationStyles.paginationLeft}>
          <button className="primaryButton inverse" onClick={onPrevious} disabled={currentPage === 1}>
            {t('pagination.previous')}
          </button>
          <button className="primaryButton inverse" onClick={onNext} disabled={currentPage === totalPages}>
            {t('pagination.next')}
          </button>
        </div>
        <p>
          {t('pagination.page', {
            currentPage: currentPage,
            totalPages: totalPages,
          })}
        </p>
      </div>
      <div className={`${paginationStyles.pagination} ${paginationStyles.mobile} ${paginationStyles.mobileSmall}`}>
        <button className="primaryButton inverse mobileSmall" onClick={onPrevious} disabled={currentPage === 1}>
          {t('pagination.previous')}
        </button>
        <p>
          {t('pagination.page', {
            currentPage: currentPage,
            totalPages: totalPages,
          })}
        </p>
        <button className="primaryButton inverse mobileSmall" onClick={onNext} disabled={currentPage === totalPages}>
          {t('pagination.next')}
        </button>
      </div>
    </div>
  );
};
export default Pagination;
